import Cookies from 'js-cookie'

import { maLogger } from '@/base/logger'

const isProd = import.meta.env.PROD && import.meta.env.VITE_APP_HEROKU_ENV === 'production'

export const c = {
  MA: 'MA',
  MISSING_INFO_CLOSE: 'missingInfoClose',
}

// set storage value
export function set(key, value, expires, options) {
  Cookies.remove(key, { domain: '.mobileaction.co' })

  Cookies.set(key, JSON.stringify(value), {
    ...options,
    expires: expires || 30,
  })
}

export function get(key) {
  const val = Cookies.get(key)
  try {
    return JSON.parse(val)
  }
  catch (error) {
    maLogger.warn(`MaCookieStorage: failed to parse ${key}`, error)
    return val
  }
}

export function remove(key) {
  Cookies.remove(key)
}

export function reduce(key, value) {
  if (typeof value !== 'undefined') {
    set(key, value)
  }
  return get(key, value)
}

export const AUTH_COOKIE_OPTIONS = {
  path: '/',
  secure: true,
  sameSite: 'Strict',
  domain: window.location.hostname.search('mobileaction.co') === -1 ? undefined : `.mobileaction.co`,
}

// Global Cookie Names
export const COOKIES = Object.freeze({
  AUTH: 'MA_userAuth',
  IMPERSONATOR_USERNAME: 'MA_impersonatorUsername',
  PDF_REPORT_PAGE_PARAMS: 'MA_pdfPageParams',
})

// TODO: It can be removed after June 6, 2025.
export function removeDuplicateCookie() {
  if (isProd) {
    Cookies.remove(COOKIES.AUTH, {
      path: '/',
    })
    maLogger.info('MA Cookie Storage: removed duplicate cookie')
  }
}
